export default "__VITE_ASSET__Ct05NIE$__"